export const professionalSkills = [
  "TypeScript",
  // eslint-disable-next-line
  "JavaScript: ES6+ features",
  "React",
  "Redux (Toolkit)",
  "Redux-Saga",
  "Redux-Thunk",
  "React Router",
  "React Hooks",
  "React Context",
  "Scss",
  "Styled-components",
  "Responsive Web Design",
  "CSS Grid",
  "CSS Flexbox",
  "Leaflet",
  "E-commerce",
  "Semantic & accessible HTML",
  "IndexedDB",
  "LocalStorage",
  "Teamwork",
  "Immutability",
  "Error handling",
  "Working with API (fetch, axios)",
  // eslint-disable-next-line
  "Promises, Async/Await",
  "Git",
  "Bitbucket",
  "Trello",
  "CSS BEM convention",
  "Markdown",
  "GitHub Pull Requests & Review",
  "Scrum",
  "NPM, yarn",
  "AWS: Amplify",
  "PHP 7.x",
  "Symfony 4.x",
  "Doctrine",
  "MySQL",
  "Twig",
];

export const projectSkills = [
  "Next.js",
  "Tailwind CSS",
  "React Query",
  "Jest",
  "Node.js",
  "Express",
  "MongoDB (Mongoose)",
  "JWT",
];

export const futureSkills = [
  "Server-side rendering",
  "GraphQL",
  "Web Sockets",
];